<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

interface MessageForwardedProps {
  forwardedBy?: string | null;
}

defineProps<MessageForwardedProps>();
const { t } = useI18n();
</script>

<template>
  <span
    class="leading-none overflow-hidden text-ellipsis shrink max-w-32 whitespace-nowrap mr-2 text-xs"
    :title="forwardedBy ?? ''"
  >
    <span class="mi md-16 shortcut align-text-bottom leading-[12px]" />
    <template v-if="forwardedBy">
      {{ t('message.forwardedBy', [forwardedBy]) }}
    </template>
    <template v-else>
      {{ t('message.forwardedMessage') }}
    </template>
  </span>
</template>
